import React, { useEffect, useState } from 'react';
import { Badge, Container, Image } from 'react-bootstrap';
import Zoom from 'react-medium-image-zoom';
import PlaceHolder from 'assets/placeholder.webp';
import DefaultCurrency from 'components/DefaultCurrency';
import { useFormContext } from 'contexts/FormContext';
import Loading from 'react-loading-components';
import { useAppContext } from 'contexts/AppContext';

const ItemHeader = ({ item }) => {
  // contexts
  const { appState } = useAppContext();
  const { formState } = useFormContext();
  const [price, setPrice] = useState(null);
  useEffect(() => {
    const detail = formState.details.find(
      (x) => !x.extra && x.item.id == item.id
    );
    if (!detail) {
      const pld = formState.info.priceList?.details.find(
        (pl) => pl.item.id == item.id
      );
      if (pld) setPrice(pld.suggestedSalesPrice);
      else setPrice(item.suggestedSalesPrice);
    }
  }, [item, formState.info.priceList]);

  return (
    <React.Fragment>
      <style>{`
        .tag-badge-custom {
          background-color: rgba(248, 249, 250, 0.85) !important;
        }
        .tag-scroll-container {
          scrollbar-width: thin;
          scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
        }
        .tag-scroll-container::-webkit-scrollbar {
          width: 6px;
        }
        .tag-scroll-container::-webkit-scrollbar-track {
          background: transparent;
        }
        .tag-scroll-container::-webkit-scrollbar-thumb {
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 1px;
        }
      `}</style>
      <Container fluid className='text-center p-0'>
        <Zoom>
          <Image
            height='200vh'
            src={item.image != "" ? item.image : PlaceHolder}
            onErrorCapture={({ currentTarget }) => {
              console.log('onErrorCapture');
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = PlaceHolder;
            }}
            onError={({ currentTarget }) => {
              console.log('onError');
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = PlaceHolder;
            }}
          />
        </Zoom>
      </Container>
      <p className='position-absolute top-0 m-0 text-white p-1 bg-secondary' style={{ borderRadius: "5px 0 5px 0" }}>
        {item.itemGroup?.name}
      </p>
      <div className="position-absolute top-0 right-0 d-flex flex-column align-items-end">
        <div 
          className="tag-scroll-container"
          style={{ 
            height: '120px', 
            overflowY: 'auto', 
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            width: '100%',
            direction: 'rtl'
          }}
        >
          <div style={{ direction: 'ltr', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
            {item?.tags?.map(tag => (
              <Badge 
                key={tag}
                style={{ maxWidth: '18ch', wordWrap: 'break-word', whiteSpace: 'normal', flexShrink: 0 }} 
                className="mb-1 fw-normal border text-dark tag-badge-custom"
              >
                <p className='m-0 p-0 text-dark fw-bold'>{tag}</p>
              </Badge>
            ))}
          </div>
        </div>
      </div>
      {appState.auth.user.entity.config.inventory && (
        <p
          className='position-absolute bottom-0 m-0 text-white p-1 rounded-top-right'
          style={{ backgroundColor: '#ad6704' }}
        >
          {!isNaN(formState.levelHistory[item.id]) &&
            formState.levelHistory[item.id].toFixed(2)}
          {isNaN(formState.levelHistory[item.id]) && formState.levelLoading && (
            <Loading type='three_dots' width={15} height={15} />
          )}{' '}
          <span style={{ fontSize: '12px' }}>{item.uom?.name}</span>
        </p>
      )}
      <p
        className='position-absolute bottom-0 right-0 m-0 text-white p-1 rounded-top-left'
        style={{ backgroundColor: '#1ab394' }}
      >
        <DefaultCurrency value={price} />
      </p>
    </React.Fragment>
  );
};

export default ItemHeader;
